// 链接
export default process.env.NODE_ENV === "development"
  ? "https://sdx.babm.cn"
  : "";
